ready().then(function() {

    /**
     *  On several page templates are authors shown in cards. They all have in common that they have a description
     *  On several device widths our description lenght must be limited to an X no. of characters
     *  In our card-author twig file the limit of the description/excerpt is set to a high no. of characters
     */
    window.trimAuthorDescriptionCards = () => {

        var authorcardcount = $('.swiper-wrapper .card-author').length;

        // Provide defaults and override with themeSettings variables (if present)
        var config = $.extend({
            'default': 250,
            'eq1': 80,
            'gt2_large': 60,
            'gt2_small': 50,
            'archive': 70
        }, themeSettings.card_author_max_length || {});

        $('.card-description p').each(function() {
            const authordesc = this.innerHTML;
            var maxlength = config.default; // always a default maxLenght

            /**
             *  create a few different max. number of characters. Depending on page template, no. of authors shown, and screenwidth.
             */

            // based on page template
            if($('body').hasClass('post-type-archive-wpg_author')) {
                maxlength = config.archive // maximum number of characters to extract
            }
            // based on screen width - but check if it's NOT the archive template
            // and the page does NOT contain more then 2 author cards in the swiper wrapper
            if(! $('body').hasClass('post-type-archive-wpg_author') && authorcardcount === 1 ) {
                if (window.screen.width < mdWidth ) {
                    maxlength = config.eq1;
                }
            }
            // based on screen width - but check if it's NOT the archive template
            // and the page DOES contain more then 2 author cards in the swiper wrapper
            if (! $('body').hasClass('post-type-archive-wpg_author') && authorcardcount > 1 ) {
                if (window.screen.width >= lgWidth ) {
                    maxlength = config.gt2_large;
                }
                if (window.screen.width < lgWidth) {
                    maxlength = config.gt2_small;
                }
            }

            // for some miraculous reason there are empty characters before every string, so remove them

            var trimmedauthordesc = authordesc.trim().substr(0, maxlength);

            // re-trim if we are in the middle of a word
            trimmedauthordesc = trimmedauthordesc.substr(0, Math.min(trimmedauthordesc.length, trimmedauthordesc.lastIndexOf(" ")));

            // render the trimmed author description
            this.innerHTML = trimmedauthordesc + '...';
        });
    }

    trimAuthorDescriptionCards();

    window.trimText = () => {
        $("[data-text-length]").each(function () {
            const description = this.innerHTML;
            var configKey = $(this).data('text-length');

            var trimText = (maxLength) => {
                var trimmedText = description.trim().substr(0, maxLength);

                // re-trim if we are in the middle of a word
                trimmedText = trimmedText.substr(0, Math.min(trimmedText.length, trimmedText.lastIndexOf(" ")));

                // render the trimmed featured description
                this.innerHTML = trimmedText + '...';
            }

            // Handle Media Query if it matches the breakpoint - mediaBreakPoint-vars are stored in the global variables.js
            const handleMediaQuery = () => {

                // usage in section kassa-koopjes
                if($('section').hasClass('section-kassa-koopjes')) {
                    if (mediaBreakPointMaxXxs.matches === true ) {
                        trimText(themeSettings.toaster_book_blurb_max_length.max_xxs_width)
                    }
                    if (mediaBreakPointMinSmMaxMd.matches === true ) {
                        trimText(themeSettings.toaster_book_blurb_max_length.min_sm_width)
                    }
                    if (mediaBreakPointMinLg.matches === true ) {
                        trimText(themeSettings.toaster_book_blurb_max_length.min_lg_width)
                    }
                }
            }

            // run by default
            handleMediaQuery();
            // and on media size change
            window.addEventListener('resize', () => {
                handleMediaQuery();
            });

        });
    };

    trimText();    
});
